(function(){
  function reveal(){
    var els=document.querySelectorAll('.os-reveal:not(.in)');
    if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion:reduce)').matches){els.forEach(function(e){e.classList.add('in')});return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}})},{threshold:.1});
    els.forEach(function(e){io.observe(e)});
    setTimeout(function(){els.forEach(function(e){e.classList.add('in')})},2500);
  }
  function countdowns(){
    document.querySelectorAll('[data-os-cd]').forEach(function(cd){
      if(cd._t) return;
      var t=new Date(cd.getAttribute('data-os-cd').replace(' ','T')).getTime(); if(isNaN(t)) return;
      function pad(n){return String(n).padStart(2,'0')}
      function tick(){var s=Math.max(0,Math.floor((t-Date.now())/1000));
        var v={d:Math.floor(s/86400),h:Math.floor(s%86400/3600),m:Math.floor(s%3600/60),s:s%60};
        cd.querySelectorAll('[data-u]').forEach(function(b){b.textContent=pad(v[b.getAttribute('data-u')])});}
      tick(); cd._t=setInterval(tick,1000);
    });
  }
  function filters(){
    document.querySelectorAll('[data-os-filter]').forEach(function(bar){
      if(bar._f) return; bar._f=1;
      var root=bar.closest('.os');
      bar.addEventListener('click',function(e){
        var b=e.target.closest('[data-f]'); if(!b) return;
        bar.querySelectorAll('[data-f]').forEach(function(x){x.classList.toggle('on',x===b)});
        var f=b.getAttribute('data-f');
        root.querySelectorAll('.os-note').forEach(function(n){n.classList.toggle('hide',f!=='all'&&(n.getAttribute('data-cat')||'')!==f)});
        var feat=root.querySelector('.os-feat'); if(feat) feat.style.display=(f==='all'||f==='apertura')?'':'none';
      });
    });
  }
  function init(){reveal();countdowns();filters();}
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
